/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum TransitTimeSourceType {
  CarrierApi = "carrier_api",
  CarrierWebsite = "carrier_website",
  Fallback = "fallback",
  Truckload = "truckload",
  FixedDays = "fixed_days",
  TransitTimeSheet = "transit_time_sheet",
}

export function instanceOfTransitTimeSourceType(value: any): boolean {
  for (const key in TransitTimeSourceType) {
    if (Object.prototype.hasOwnProperty.call(TransitTimeSourceType, key)) {
      if (
        TransitTimeSourceType[key as keyof typeof TransitTimeSourceType] ===
        value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function TransitTimeSourceTypeFromJSON(
  json: any,
): TransitTimeSourceType {
  return TransitTimeSourceTypeFromJSONTyped(json, false);
}

export function TransitTimeSourceTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TransitTimeSourceType {
  return json as TransitTimeSourceType;
}

export function TransitTimeSourceTypeToJSON(
  value?: TransitTimeSourceType | null,
): any {
  return value as any;
}

export function TransitTimeSourceTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): TransitTimeSourceType {
  return value as TransitTimeSourceType;
}
